import script from "./ChangePaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./ChangePaymentMethod.vue?vue&type=style&index=0&id=22d7b11a&lang=scss"

const __exports__ = script;

export default __exports__